




















































































































import { Component, Ref, Vue, Watch, Prop } from "vue-property-decorator";
import { storePasien } from "@/store/modules/pasien";
import { userModule } from "@/store/modules/user";
import ModalBatalSoap from "@/components/modal/ModalBatalSoap.vue";
import { appModule } from "@/store/modules/app";
import SoapRanapStore from "@/store/modules/SoapRanapStore";
import moment from "moment";
import RegisterKunjungan from "@/store/modules/RegisterKunjungan";
import SoapInput from "@/components/soap/SoapInput.vue";
import HandOverInput from "@/components/soap/HandOverInput.vue";
import ReadBackInput from "@/components/soap/ReadBackInput.vue";
import AdimeInput from "@/components/soap/AdimeInput.vue";
import CpptIntegratedList from "@/components/soap/CpptIntegratedList.vue";
// import ModalKonfirmasi from "@/components/modal/KonfirmasiLogout.vue";
import CpptRanapStore from "@/store/modules/CpptRanapStore";
import ptiStore from "@/store/modules/pti";
import BundelSuketGadar from "@/components/AsesmenAwalGadar/BundelSuketGadar.vue";
import RencanaAsuhanTerintegrasiV2 from "@/components/soap/RencanaAsuhanTerintegrasiV2.vue";

@Component({
  components: {
    ModalBatalSoap,
    SoapInput,
    CpptIntegratedList,
    HandOverInput,
    ReadBackInput,
    AdimeInput,
    BundelSuketGadar,
    RencanaAsuhanTerintegrasiV2
  },
  inject: {
    pageIsReadOnly: { from: "isReadOnly", default: () => () => false }
  }
})
export default class CpptRanapPage extends Vue {
  @Prop() isActive!: boolean;
  @Prop({ default: true }) readonly showVerifButton?: boolean;
  @Prop({ type: Boolean, default: true }) readonly enableTransferLock!: boolean;
  @Prop({ type: Boolean, default: false }) readonly showBundelSuket!: boolean;
  @Prop({ type: String, default: "tab-soap" }) readonly defaultTab!: string;
  @Prop({ type: Boolean, default: false })
  readonly enableRencanaAsuhanV2!: boolean;
  pageIsReadOnly!: () => boolean;

  @Ref() examinedAtPicker: HTMLElement;
  @Ref() readonly sub;

  isFormValid = true;
  validasi = [v => !!v || "*Kolom ini harus diisi"];

  id = null;
  subjective: string = null;
  objective: string = null;
  assesment: string = null;
  plan: string = null;
  instruksi: string = null;
  examinedAt: string | Date = null;

  modalOpenKonfirmasi = false;
  msgConfirm = "";
  tab = this.defaultTab;
  tampilan: "v1" | "v2" = "v1";
  v2PernahDibuka = false;

  @Watch("tampilan")
  onTampilan(val: string) {
    if (val === "v2") {
      this.v2PernahDibuka = true;
      return;
    }
    // Slider v-tabs dihitung saat tampil; picu ulang setelah keluar dari display:none.
    this.$nextTick(() => window.dispatchEvent(new Event("resize")));
  }

  modalConfirmed(soapItem) {
    this.soapItem = soapItem;
  }

  @Watch("examinedAt")
  changedExaminedAt(val) {
    if (!val) {
      this.examinedAtPicker["clearHandler"]();
    }
  }

  removing = false;
  saving = false;

  showBatal = false;

  timePickerProps = { format: "24hr", scrollable: true };
  datePickerProps = { locale: "id", max: moment().format("YYYY-MM-DD") };
  dateTimeFieldProps = { outlined: true, dense: true, "hide-details": "auto" };

  soapItem = null;
  adimeItem = null;
  readbackItem = null;
  handoverItem = null;
  selectToVerif = [];

  offsetTimeSoapForVerif = moment()
    .subtract(1, "days")
    .format("YYYY-MM-DD");

  get tabs() {
    return [
      {
        name: "SOAP",
        route: "#tab-soap",
        tabId: "tab-soap",
        component: "SoapInput",
        disabled: false,
        props: {
          isActive: this.tab === "tab-soap",
          readonly: this.isReadonly || this.isTransferLocked
        },
        model: this.soapItem,
        onInput: val => {
          console.log("on input soap", val);
          this.soapItem = val;
        }
      },
      {
        name: "ADIME",
        route: "#tab-adime",
        tabId: "tab-adime",
        component: "AdimeInput",
        disabled: false,
        props: {
          isActive: this.tab === "tab-adime",
          readonly: this.isReadonly
        },
        model: this.adimeItem,
        onInput: function(val) {
          //
        }
      },
      {
        name: "HandOver",
        route: "#tab-handover",
        tabId: "tab-handover",
        component: "HandOverInput",
        disabled: false,
        props: {
          isActive: this.tab === "tab-handover",
          readonly: this.isReadonly
        },
        model: this.handoverItem,
        onInput: function(val) {
          //
        }
      },
      {
        name: "Read Back",
        route: "#tab-readback",
        tabId: "tab-readback",
        component: "ReadBackInput",
        disabled: false,
        props: {
          isActive: this.tab === "tab-readback",
          readonly: this.isReadonly
        },
        model: this.readbackItem,
        onInput: function(val) {
          //
        }
      }
    ];
  }

  get showGenerateBtn() {
    return userModule.isMedis && this.soapList?.length < 1;
  }

  get soapList() {
    return SoapRanapStore.soapList;
  }

  get canEditSoap() {
    if (!this.id) return false;
    return userModule.canAccessForm("cppt", "edit");
  }

  get canMakeSoap() {
    return userModule.canAccessForm("cppt", "create");
  }

  get isDokter() {
    return ["Dokter", "Psikolog"].includes(this.stateUser.profesi);
  }

  get isPerawat() {
    return ["Perawat", "Bidan"].includes(this.stateUser.profesi);
  }

  get registerId(): number {
    return parseInt(this.$route.params.register);
  }

  get pasienRm(): number {
    return storePasien.identitasPasien?.rm
      ? parseInt(storePasien.identitasPasien.rm)
      : null;
  }

  get loadingList(): boolean {
    return SoapRanapStore.loadingList;
  }

  get stateUser() {
    return userModule.user;
  }

  get formatedExaminedAt() {
    return this.examinedAt
      ? moment(this.examinedAt).format("YYYY-MM-DD HH:mm:ss")
      : null;
  }

  get registerKunjungan() {
    return RegisterKunjungan.register;
  }

  get canShowVerifSoapDialog() {
    return this.isSp || !this.stateUser.isMedis;
    // return this.isSp && this.isDpjp;
    // return true;
  }

  get isSp() {
    return this.stateUser.cdoc?.idsp == "1";
  }

  get isDpjp() {
    return this.registerKunjungan?.dokter?.id == this.stateUser.id;
  }

  get input() {
    return {
      register_id: this.registerId,
      pasien_cm: this.pasienRm,
      unit_id: this.stateUser.unit_id,
      subjective: this.subjective,
      objective: this.objective,
      assesment: this.assesment,
      plan: this.plan,
      instruksi: this.instruksi,
      examined_at: this.formatedExaminedAt
    };
  }

  get isReadonly() {
    return this.pageIsReadOnly();
  }

  get isTransferLocked(): boolean {
    if (!this.enableTransferLock) return false;
    return ptiStore.cpptLocked;
  }

  bukaTabTransferInternal() {
    this.$emit("navigate-tab", "tab-transfer-internal");
  }

  get registerNoAktif(): number | null {
    const reg = RegisterKunjungan.register?.no ?? null;
    return reg ? Number(reg) : null;
  }

  muatTransferInternal() {
    ptiStore.fetchByRegister(this.registerNoAktif);
  }

  @Watch("registerNoAktif", { immediate: true })
  onRegisterAktifBerubah(val: number | null) {
    if (val) this.muatTransferInternal();
  }

  @Watch("isActive")
  onCpptActive(val: boolean) {
    if (val) this.muatTransferInternal();
  }

  mounted() {
    this.$root.$on("reload-ranap-global", this.muatTransferInternal);
  }

  beforeDestroy() {
    this.$root.$off("reload-ranap-global", this.muatTransferInternal);
  }

  getcanVerifySoap(item: any) {
    return this.isDpjp && this.stateUser.id != item.user_id;
  }

  async getByRegister() {
    if (this.stateUser.isMedis) {
      await SoapRanapStore.getByRegister(this.registerId);
      await CpptRanapStore.getAdimeByRegister(this.registerId);
      await CpptRanapStore.getReadbackByRegister(this.registerId);
    } else {
      await CpptRanapStore.getHandoverByRegister(this.registerId);
    }
  }

  removeHandler() {
    const q = confirm("Menghapus SOAP ini?");

    if (q) {
      // this.remove();
      this.showBatal = true;
    }
  }

  editSoapItem(item) {
    if (item.user.id == this.stateUser.id) {
      this.id = item.id;
      this.subjective = item.subjective;
      this.objective = item.objective;
      this.assesment = item.assesment;
      this.plan = item.plan;
      this.instruksi = item.instruksi;
      this.examinedAt = item.examined_at ? new Date(item.examined_at) : null;
    } else {
      appModule.sendErrorAlert(
        "Tidak dapat mengubah SOAP yang dituliskan orang lain!"
      );
    }
  }

  copySoap(item) {
    if (item.user.id == this.stateUser.id) {
      if (this.id) {
        appModule.sendErrorAlert("Copy SOAP Hanya untuk Pembuatan SOAP Baru!");
      } else {
        this.id = null;
        this.subjective = item.subjective;
        this.objective = item.objective;
        this.assesment = item.assesment;
        this.plan = item.plan;
        this.instruksi = item.instruksi;
        this.examinedAt = null;
      }
    } else {
      appModule.sendErrorAlert(
        "Tidak dapat Salin SOAP yang dituliskan orang lain!"
      );
    }
    //copy soap hanya untuk pembuatan soap baru
  }

  makeNewSoap(cat = "soap") {
    // this.soapItem = null;
    if (`${cat}Item` in this) {
      this.tab = `tab-${cat}`;
      this[`${cat}Item`] = null;
      console.log("make new...", this.tab, this[`${cat}Item`]);
    }
  }

  formatDate(date) {
    return date ? moment(date).format("DD-MM-YYYY HH:mm") : null;
  }

  showEditButton(user) {
    return user.id == this.stateUser.id;
  }

  verificatorUserId = null;
  verifiedAt = null;

  confirmPrompt(msg, fnCb) {
    const conf = confirm(msg);

    if (conf) {
      fnCb();
    }
  }

  putSoapItem(soapItem) {
    // timpa edit soap dg item copy soap tidak bisa dilakukan!
    if (this.soapItem && this.soapItem.id && !soapItem.id) {
      appModule.sendErrorAlert(
        "Copy SOAP hanya bisa untuk Pembuatan SOAP Baru!"
      );
      return false;
    } else if (this.soapItem && !this.soapItem.id && soapItem.id) {
      const q = this.confirmPrompt(
        "SOAP yang sedang dibuat akan ditimpa riwayat SOAP lain untuk diubah. Lanjutkan?",
        () => {
          this.soapItem = soapItem;
        }
      );
      return false;
    }

    this.tab = "tab-soap";
    this.soapItem = soapItem;

    return true;
  }

  putItem(cat, item) {
    if (`${cat}Item` in this) {
      this.tab = `tab-${cat}`;

      this.$nextTick(() => {
        setTimeout(() => {
          this[`${cat}Item`] = item;
        }, 100);
      });
    }
  }
}
